export const SERVER_GENERAL_ERROR_MESSAGE = 'Something appears to be wrong. Please try again in a few minutes.';
export const SERVER_GENERAL_ERROR_MESSAGE2 = 'An error occurred. Please try again or contact us <a class="link-1 small-link" href="/company/contact-us">here</a>.';
